import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-form-error',
  templateUrl: './form-error.component.html',
  styleUrl: './form-error.component.scss',
})
export class FormErrorComponent {
  @Input() control!: FormControl | AbstractControl<any, any>;
  @Input() name!: any;
  @Input() otherMessage?: string;

  ngOnInit(): void {}
}
